import { makeObservable } from 'mobx'

import SharedStore from 'shared/stores/shared.store'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { apiClient } from 'utils/requests.utils'

import { ProductSettingsApi, createProductSettingsApi } from 'shop/api/productSettings.api'

export class ProductSettingsStore extends SharedStore<any> {
  storeName = 'ProductSettingsStore'
  declare childApi: ProductSettingsApi

  constructor(root: ShopRootStore) {
    super()
    this.childApi = createProductSettingsApi(root?.apiClient ?? apiClient)
    makeObservable(this)
  }
}
